import Link from 'next/link';
import PropTypes from 'prop-types';
import React from 'react';

import {ROLES_NAMES} from '@/src/app/constants/roles';
import USER_EMPTY_AVATAR from '@/src/app/constants/userEmptyAvatar';
import useRoutePaths from '@/src/hooks/useRoutePaths';

import {Text, UserPreview} from '../../ui';
import css from '../styles/Review.module.css';

const Review = ({user, comment, rating}) => {
  const {USER_PROFILE, CLINIC_TARGET_PROFILE} = useRoutePaths();

  const link =
    user.type === ROLES_NAMES.CLINIC
      ? CLINIC_TARGET_PROFILE.getLink(user.slug)
      : USER_PROFILE.getLink(user.slug);

  const Tag = user.name ? Link : 'div';

  return (
    <div className={css.review}>
      <Tag href={link}>
        <a>
          <UserPreview
            size={'extraSmall'}
            rating={rating}
            image={user.name ? user.image : USER_EMPTY_AVATAR}
            name={user.name}
            withRating
            showZeroRating
          />
        </a>
      </Tag>
      <div className={css.reviewWrapper}>
        <Text
          color={Text.COLOR.GREY}
          fontSize={Text.FONT_SIZE.SIZE_16}
          lineHeight={Text.LINE_HEIGHT.LINE_HEIGHT_1_6}
        >
          {comment}
        </Text>
      </div>
    </div>
  );
};

Review.propTypes = {
  user: PropTypes.object.isRequired,
  comment: PropTypes.string.isRequired,
  rating: PropTypes.number.isRequired,
};

export default Review;
